import React from "react";
import { Breadcrumbs, Button, PageHeader } from "@opendate-app/setlist";

import { useActionContext } from "./ActionContainer";
import { listHref } from "../../shared/listUrlState";

const ActionShowHeader = () => {
  const {
    team,
    venueOwnership,
    campaign,
    action,
    template,
    body,
    isEmailTemplate,
    updateAction,
    isAutosaving,
  } = useActionContext();

  const indexPath = `/teams/${team.id}/campaigns`;
  const campaignPath = `${indexPath}/${campaign.id}`;

  const saveAction = () => {
    const requestBody = isEmailTemplate ? {
      campaign_action: {
        beefree_template_attributes: {
          id: action.beefree_template.id,
          template: template,
        },
      }
    } : {
      campaign_action: {
        body: body,
      }
    };

    updateAction(requestBody);
  };

  return (
    <PageHeader
      breadcrumbs={(
        <Breadcrumbs
          items={[
            { label: "Automations", href: listHref(indexPath) },
            { label: venueOwnership.venueable.name },
            { label: campaign.campaign_template.name, href: campaignPath },
          ]}
        />
      )}
      back={{ label: campaign.campaign_template.name, href: campaignPath }}
      title={campaign.campaign_template.name}
      supportingText={campaign.campaign_template.description}
      actions={(
        <Button variant="primary" onClick={saveAction} disabled={isAutosaving}>
          {isAutosaving ? "Saving…" : "Save"}
        </Button>
      )}
    />
  );
};

export default ActionShowHeader;
